/**
 *
 */
const addons = {

	addons: [],


	update: function( scene ) {

		const character = gameCharacter.character;

		for ( let i = this.addons.length - 1; i >= 0; i-- ) {

			let addon = this.addons[ i ];

			if ( 'undefined' === typeof addon ) {
				continue;
			}

			if ( character.x > addon.x && character.x < addon.x + settings.tileWidth ) {
				if ( character.y > addon.y && character.y < addon.y + settings.tileWidth ) {

					this.do( addon.addonType );
					this.collect( addon );

					// Delete the item from the list.
					this.addons[ i ] = undefined;

				}
			}

		}

	},


	/**
	 *
	 */
	add: function( scene ) {

		this.addAnimations( scene );

		// Reset list of addons.
		this.addons = [];

		for ( let y = 0; y < settings.height; y++ ) {
			for ( let x = 0; x < settings.width; x++ ) {

				let addon = mazes.addons[ y ][ x ];
				if ( '' !== addon && '-' !== addon ) {
					this.new( scene, x, y, addon );
				}

			}
		}

	},


	do: function( type ) {

		// console.log( 'do', type );

		switch ( type ) {

			case 'money':
				gameData.earn( 1 );
				break;

			case 'money-10':
				gameData.earn( 10 );
				break;

			case 'time':
				gameTimer.add( 5 );
				break;

			case 'energy':
				gameplay.faster();
				break;
		}

	},


	/**
	 *
	 */
	new: function( scene, x, y, type = 'money' ) {

		let tileX = ( x ) * settings.tileWidth;
		let tileY = ( y ) * settings.tileHeight;

		let addon = scene.add.sprite( tileX, tileY, 'addon-' + type );

		// Set the anchor to the middle to center the coin on the tile.
		addon.setOrigin( 0, 0.3 );

		// Play the spin animation by default.
		addon.anims.play( 'spin-' + type );

		addon.depth = y + 10;

		addon.addonType = type;

		// addon.bringToTop();

		this.addons.push( addon );

	},


	/**
	 *
	 */
	collect: function( addon ) {

		// const type = addon.addonType;
		// const animation = addon.anims.play( 'explode-' + type );

		addon.destroy();

		// // When the animation completes, kill the coin.
		// animation.onComplete.add(
		// 	addon.kill,
		// 	addon
		// );

	},


	/**
	 *
	 */
	addAnimations: function( scene ) {

		// Money 1.
		scene.anims.create(
			{
				key: 'spin-money',
				frames: scene.anims.generateFrameNumbers( 'addon-money', { frames: [ 0, 1, 2, 3, 4, 5, 6, 7 ] } ),
				frameRate: 5,
				yoyo: false,
				repeat: -1
			}
		);

		scene.anims.create(
			{
				key: 'explode-money',
				frames: scene.anims.generateFrameNumbers( 'addon-money', { frames: [ 0, 1, 2 ] } ),
				frameRate: 5,
				repeat: 1
			}
		);

		// Money 10.
		scene.anims.create(
			{
				key: 'spin-money-10',
				frames: scene.anims.generateFrameNumbers( 'addon-money-10', { frames: [ 0, 1, 2, 3, 4, 5, 6, 7 ] } ),
				frameRate: 5,
				yoyo: false,
				repeat: -1
			}
		);

		scene.anims.create(
			{
				key: 'explode-money-10',
				frames: scene.anims.generateFrameNumbers( 'addon-money', { frames: [ 0, 1, 2 ] } ),
				frameRate: 5,
				repeat: 1
			}
		);

		// Energy.
		scene.anims.create(
			{
				key: 'spin-energy',
				frames: scene.anims.generateFrameNumbers( 'addon-energy', { frames: [ 0, 1, 2, 1 ] } ),
				frameRate: 5,
				yoyo: false,
				repeat: -1
			}
		);

		scene.anims.create(
			{
				key: 'explode-energy',
				frames: scene.anims.generateFrameNumbers( 'addon-money', { frames: [ 0, 1, 2 ] } ),
				frameRate: 5,
				repeat: 1
			}
		);

		// Time.
		scene.anims.create(
			{
				key: 'spin-time',
				frames: scene.anims.generateFrameNumbers( 'addon-time', { frames: [ 0, 1, 2, 3, 4, 5, 6, 7 ] } ),
				frameRate: 5,
				yoyo: false,
				repeat: -1
			}
		);

		scene.anims.create(
			{
				key: 'explode-time',
				frames: scene.anims.generateFrameNumbers( 'addon-money', { frames: [ 0, 1, 2 ] } ),
				frameRate: 5,
				repeat: 1
			}
		);

	},

};
